// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// // import { makeStyles } from "@mui/material/styles";
// import { makeStyles } from "@mui/styles";

// import Navbar from "./Navbar";
// import {
//   Avatar,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   List,
//   ListItem,
//   ListItemText,
//   Paper,
//   TextField,
//   Typography,
// } from "@mui/material";
// import { deepPurple } from "@mui/material/colors";
// import axios from "axios";
// import config from "../config.js";
// import Cookies from "universal-cookie";
// import { ReactTabulator } from "react-tabulator";
// import swal from "sweetalert";
// import "../App.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faEdit,
//   faTimes,
//   faCheck,
//   faUserCheck,
// } from "@fortawesome/free-solid-svg-icons";
// import { BsKey } from "react-icons/bs";
// import default_avatar from "../images/default-user-avatar.jpg";
// import mixpanel from "mixpanel-browser";

// const MAX_SIZE = 2 * 1024 * 1024; // 2 MB
// const MAX_WIDTH = 400; // 400 pixels
// const MAX_HEIGHT = 400; // 400 pixels

// const useStyles = makeStyles((theme) => ({
//   avatar: { width: theme.spacing(16), height: theme.spacing(16) },
//   button: {
//     backgroundColor: deepPurple[500],
//     color: theme.palette.getContrastText(deepPurple[500]),
//     "&:hover": { backgroundColor: deepPurple[700] },
//   },
//   avatarBox: {
//     display: "flex",
//     alignItems: "center",
//     borderRadius: "8px",
//     boxShadow: "1px 1px 8px #6a5f5f",
//     padding: "1rem",
//     flexDirection: "column",
//     minHeight: "270px",
//     justifyContent: "space-evenly",
//     marginBottom: "2rem",
//   },
//   listItem: { fontWeight: "bold" },
//   paperList: {
//     width: "100%",
//     maxHeight: 250,
//     maxWidth: 360,
//     backgroundColor: "#00000059",
//     overflow: "auto",
//     display: "flex",
//     flexDirection: "column",
//     color: "#fff",
//     justifyContent: "center",
//     marginBottom: "1rem",
//   },
//   bulletArrowColors: { color: "#8c65c9" },
//   userLabelStyle: {
//     fontFamily: "'IBM Plex Sans', sans-serif",
//     fontWeight: 600,
//   },
//   userContentStyle: {
//     fontFamily: "'IBM Plex Sans', sans-serif",
//     fontWeight: 400,
//   },
//   customDivider: {
//     borderBottom: "1px solid #fff",
//     width: "90%",
//     margin: "0.5rem 0",
//   },
//   userDataRoot: {
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//   },
//   userDataMain: {
//     display: "flex",
//     position: "relative",
//     flexDirection: "column",
//     minHeight: "270px",
//     marginBottom: "2rem",
//     color: "#dee2e6",
//     justifyContent: "space-evenly",
//     width: "90%",
//     [`@media (max-width: 950px)`]: { width: "100%", fontSize: 10 },
//     borderRadius: "8px",
//     boxShadow: "1px 1px 8px #6a5f5f",
//     padding: "1rem",
//   },
//   userInputStyle: {
//     border: "none",
//     width: "78%",
//     background: "transparent",
//     color: "#fff",
//     "&:focus": { outline: "none" },
//   },
//   icon: {
//     position: "absolute",
//     fontSize: "2rem",
//     bottom: "1rem",
//     right: "1rem",
//   },
//   darkTheme: { backgroundColor: "#222", color: "#fff" },
//   imageUploadInput: {
//     display: "block",
//     maxWidth: "250px",
//     margin: "0.5rem 0",
//     padding: "0.5rem",
//     backgroundColor: "#333",
//     color: "#fff",
//     border: "none",
//     borderRadius: "0.25rem",
//   },
//   submitButton: {
//     padding: "0.5rem 1rem",
//     backgroundColor: "#007bff",
//     color: "#fff",
//     border: "none",
//     borderRadius: "0.25rem",
//     cursor: "pointer",
//     "&:hover": { backgroundColor: "#0069d9" },
//   },
//   error: { color: "red" },
// }));

// const columns = [
//   { title: "Time", field: "timestamp" },
//   { title: "User", field: "User" },
//   { title: "Message", field: "message" },
//   {
//     title: "Details",
//     field: "details",
//     formatter: function (cell) {
//       return "<button>Details</button>";
//     },
//     width: 200,
//     align: "center",
//     cellClick: function (e, cell) {
//       let detailObj = cell.getData();
//       swal(
//         "Raw Log Details",
//         JSON.stringify(detailObj, null, 2).replace(/[{}]/g, "")
//       );
//     },
//   },
// ];

// const months = [
//   "Jan",
//   "Feb",
//   "Mar",
//   "Apr",
//   "May",
//   "Jun",
//   "Jul",
//   "Aug",
//   "Sep",
//   "Oct",
//   "Nov",
//   "Dec",
// ];

// const changeTimeFormat = (date) => {
//   let time = new Date(date).toLocaleTimeString("en", {
//     timeStyle: "short",
//     hour12: false,
//     timeZone: "UTC",
//   });
//   return `${
//     months[date.getMonth()]
//   }-${date.getDate()}-${date.getFullYear()} ${time}`;
// };

// const UserProfile = () => {
//   const classes = useStyles();
//   const cookies = new Cookies();
//   const navigate = useNavigate();
//   const [image, setImage] = useState(null);
//   const [error, setError] = useState("");
//   const [assignedReports, setAssignedReports] = useState([]);
//   const [assignedDashboards, setAssignedDashboards] = useState([]);
//   const [assignedGroups, setAssignedGroups] = useState([]);
//   const [userData, setUserData] = useState({});
//   const userId = parseInt(cookies.get("userID")) || 0;
//   const [selectedRow, setSelectedRow] = useState(null);
//   const [data, setData] = useState([]);
//   const token = cookies.get("userToken") || "";
//   const [dataUrl, setDataUrl] = useState("");

//   const headers = {
//     Authorization: `Bearer ${token}`,
//     "Content-Type": "application/json",
//   };

//   // Password change states
//   const [open, setOpen] = useState(false);
//   const [step, setStep] = useState(1);
//   const [password, setPassword] = useState(false);
//   const [currentPassword, setCurrentPassword] = useState("");
//   const [newPassword, setNewPassword] = useState("");
//   const [confirmNewPassword, setConfirmNewPassword] = useState("");

//   useEffect(() => {
//     if (!userData?.photo?.data) {
//       setDataUrl("");
//       return;
//     }
//     const byteArray = new Uint8Array(userData.photo.data);
//     const blob = new Blob([byteArray], { type: "image/jpeg" });
//     const url = URL.createObjectURL(blob);

//     setDataUrl(url);

//     return () => URL.revokeObjectURL(url); // cleanup old URL
//   }, [userData]);

//   const handleOpen = () => setOpen(true);
//   const handleClose = () => {
//     setOpen(false);
//     setStep(1);
//     setPassword(false);
//     setNewPassword("");
//     setConfirmNewPassword("");
//     setCurrentPassword("");
//   };

//   const handleNext = async () => {
//     try {
//       const res = await axios.post(
//         `${config.BACKEND_URL}/profile/check-password`,
//         { password: currentPassword, userId },
//         { headers }
//       );
//       if (res.status === 200) {
//         setPassword(true);
//         if (step === 1) {
//           mixpanel.track("Step 1 Reset Password", {
//             userID: cookies.get("userID"),
//           });
//           setStep(2);
//         } else if (
//           password &&
//           step === 2 &&
//           newPassword === confirmNewPassword
//         ) {
//           mixpanel.track("Step 2 Reset Password", {
//             userID: cookies.get("userID"),
//           });
//           await axios.post(
//             `${config.BACKEND_URL}/profile/submit-password-profile`,
//             {
//               token,
//               email: userData.email,
//               name: userData.name,
//               password: newPassword,
//             },
//             { headers }
//           );
//           mixpanel.track("New Password Updated", {
//             userID: cookies.get("userID"),
//           });
//           swal("Success", "Password updated successfully!", "success");
//           handleClose();
//           // history.replace("/user-profile");
//           navigate("/user-profile", { replace: true });
//         }
//       } else {
//         throw new Error("Invalid password response");
//       }
//     } catch (err) {
//       handleClose();
//       swal(
//         "Invalid Password",
//         "Please try again with correct password",
//         "error"
//       );
//       console.error(
//         "Password check failed:",
//         err.response?.data?.message || err.message
//       );
//     }
//   };

//   const handleCurrentPasswordChange = (event) =>
//     setCurrentPassword(event.target.value);
//   const handleNewPasswordChange = (event) => setNewPassword(event.target.value);
//   const handleConfirmNewPasswordChange = (event) =>
//     setConfirmNewPassword(event.target.value);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const [reports, dashboards, groups, user] = await Promise.all([
//           axios.post(
//             `${config.BACKEND_URL}/profile/get-reports`,
//             { userId },
//             { headers }
//           ),
//           axios.post(
//             `${config.BACKEND_URL}/profile/get-dashboards`,
//             { userId },
//             { headers }
//           ),
//           axios.post(
//             `${config.BACKEND_URL}/profile/get-groups`,
//             { userId },
//             { headers }
//           ),
//           axios.post(
//             `${config.BACKEND_URL}/profile/get-user-data`,
//             { userId },
//             { headers }
//           ),
//         ]);
//         setAssignedReports(reports.data);
//         setAssignedDashboards(dashboards.data);
//         setAssignedGroups(groups.data);
//         setUserData(user.data);
//         mixpanel.track("Get Reports Dashboards Groups UserData Fetched", {
//           userID: cookies.get("userID"),
//         });
//       } catch (err) {
//         console.error(
//           "Fetch data error:",
//           err.response?.data?.message || err.message
//         );
//         swal("Error", "Failed to load user data", "error");
//       }
//     };
//     fetchData();
//   }, [userId, token]);

//   const getLog = (e) => {
//     e.preventDefault();
//     mixpanel.track("User Profile Get Log Button Clicked", {
//       userID: cookies.get("userID"),
//     });
//     let obj = Object.fromEntries(new FormData(e.target).entries());
//     let startDate = new Date(obj.startDate + "Z");
//     let endDate = new Date(obj.endDate + "Z");
//     axios
//       .get(`${config.BACKEND_URL}/logger/query`, {
//         params: {
//           from: changeTimeFormat(startDate),
//           until: changeTimeFormat(endDate),
//         },
//       })
//       .then((res) => {
//         const filteredEntries = res.data.file.filter(
//           (entry) => entry.User === userId
//         );
//         setData(filteredEntries);
//       })
//       .catch((err) => {
//         console.error(
//           "Get log error:",
//           err.response?.data?.message || err.message
//         );
//         swal("Error", "Failed to fetch logs", "error");
//       });
//   };

//   const [editMode, setEditMode] = useState(false);

//   const handleEditMode = () => setEditMode(!editMode);

//   const handleEditSubmit = async () => {
//     setEditMode(false);
//     try {
//       await axios.post(
//         `${config.BACKEND_URL}/profile/fill-details`,
//         {
//           fullname: userData.fullname,
//           email: userData.email,
//           contact: userData.contact,
//           userId,
//         },
//         { headers }
//       );
//       mixpanel.track("User Info Updated", { userID: cookies.get("userID") });
//       swal("Success", "Profile updated successfully!", "success");
//     } catch (err) {
//       console.error(
//         "Edit submit error:",
//         err.response?.data?.message || err.message
//       );
//       swal("Error", "Failed to update profile", "error");
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     if (name === "contact" && (value.length > 10 || !/^\d*$/.test(value)))
//       return;
//     // Removed email validation since it's no longer editable
//     setUserData((prev) => ({ ...prev, [name]: value }));
//   };

//   const authenticateMe = async () => {
//     try {
//       await axios.post(
//         `${config.BACKEND_URL}/profile/authenticate-user`,
//         { userId, email: userData.email, username: userData.name },
//         { headers }
//       );
//       swal(
//         "Mail Sent!",
//         "Please check your email with registered email id",
//         "warning"
//       );
//     } catch (err) {
//       console.error(
//         "Authentication error:",
//         err.response?.data?.message || err.message
//       );
//       swal("Error", "Failed to send authentication email", "error");
//     }
//   };

//   const handleImageChange = (event) => {
//     const file = event.target.files[0];
//     if (!file) return setError("No file selected.");
//     if (file.size > MAX_SIZE)
//       return setError("File size exceeds the 2 MB limit.");
//     const img = new Image();
//     const reader = new FileReader();
//     reader.onload = (e) => {
//       img.src = e.target.result;
//     };
//     img.onload = () => {
//       if (img.width > MAX_WIDTH || img.height > MAX_HEIGHT) {
//         setError(
//           `Image dimensions should not exceed ${MAX_WIDTH}x${MAX_HEIGHT} pixels.`
//         );
//       } else {
//         setError("");
//         setImage(file);
//       }
//     };
//     reader.readAsDataURL(file);
//   };

//   const handleImageSubmit = async (event) => {
//     event.preventDefault();
//     if (!image) {
//       mixpanel.track("Upload Button Clicked Without Image", {
//         userID: cookies.get("userID"),
//       });
//       return swal("Image not provided!!", "", "error");
//     }
//     const formData = new FormData();
//     formData.append("image", image);
//     formData.append("userId", userId);
//     try {
//       await axios.post(
//         `${config.BACKEND_URL}/profile/update-user-photo`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );
//       mixpanel.track("New Profile Image Uploaded", {
//         userID: cookies.get("userID"),
//       });
//       swal("Success", "Profile image updated successfully!", "success");
//       // history.replace("/user-profile");
//       navigate("/user-profile", { replace: true });
//     } catch (err) {
//       console.error(
//         "Image upload error:",
//         err.response?.data?.message || err.message
//       );
//       swal("Error", "Failed to upload image", "error");
//     }
//   };

//   const handleResetPassword = async () => {
//     try {
//       await axios.post(
//         `${config.BACKEND_URL}/profile/send-password-reset-link`,
//         { username: userData.name, email: userData.email, userId },
//         { headers }
//       );
//       swal(
//         "Password Reset Link Sent",
//         "Please check your mail to reset password",
//         "warning"
//       );
//       handleClose();
//     } catch (err) {
//       console.error(
//         "Reset password error:",
//         err.response?.data?.message || err.message
//       );
//       swal("Error", "Failed to send reset link", "error");
//     }
//   };

//   return (
//     <div className="Reports">
//       <link
//         href="https://fonts.googleapis.com/icon?family=Material+Icons"
//         rel="stylesheet"
//       />
//       <link
//         rel="preconnect"
//         href="https://fonts.gstatic.com"
//         crossOrigin="true"
//       />
//       <link
//         href="https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,300;0,400;0,500;0,600;1,200;1,300;1,400;1,500&display=swap"
//         rel="stylesheet"
//       />
//       <script src="bootstrap/dist/js/bootstrap.min.js"></script>
//       <Navbar />
//       <main className="container-fluid">
//         <br />
//         <br />
//         <br />
//         <div
//           className="row"
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             margin: "0",
//           }}
//         >
//           <div className="col-12 col-xl-3 col-md-4">
//             <div className={classes.avatarBox}>
//               {userData.photo?.data ? (
//                 <Avatar
//                   src={dataUrl}
//                   alt="User Avatar"
//                   className={classes.avatar}
//                 />
//               ) : (
//                 <Avatar
//                   src={default_avatar}
//                   alt="User Avatar"
//                   className={classes.avatar}
//                 />
//               )}
//               <form onSubmit={handleImageSubmit} style={{ width: "100%" }}>
//                 <center>
//                   <input
//                     type="file"
//                     name="image"
//                     className={classes.imageUploadInput}
//                     onChange={handleImageChange}
//                     accept="image/*"
//                   />
//                   {error && (
//                     <div className={classes.error}>
//                       <p>{error}</p>
//                     </div>
//                   )}
//                   <button
//                     type="submit"
//                     className={`${classes.submitButton} ${classes.darkTheme}`}
//                   >
//                     Upload
//                   </button>
//                 </center>
//               </form>
//               <Typography variant="h5">{userData.name}</Typography>
//               {userId === 99999 || userData.isEmailAuthenticated ? (
//                 <div style={{ display: "flex", alignItems: "center" }}>
//                   <FontAwesomeIcon
//                     icon={faUserCheck}
//                     style={{ color: "#ADD8E6", fontSize: "1.5rem" }}
//                   />
//                   <span style={{ fontSize: "1.5rem", marginLeft: "0.5rem" }}>
//                     Verified
//                   </span>
//                 </div>
//               ) : (
//                 <Button
//                   variant="contained"
//                   className={classes.button}
//                   style={{ borderRadius: "1rem" }}
//                   onClick={authenticateMe}
//                 >
//                   Authenticate
//                 </Button>
//               )}
//               <div>
//                 <Button
//                   variant="contained"
//                   startIcon={<BsKey />}
//                   onClick={handleOpen}
//                 >
//                   CHANGE PASSWORD
//                 </Button>
//                 <Dialog
//                   open={open}
//                   onClose={handleClose}
//                   PaperProps={{
//                     style: {
//                       backgroundColor: "#333",
//                       color: "#fff",
//                       boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.5)",
//                     },
//                   }}
//                 >
//                   {step === 1 && (
//                     <>
//                       <DialogTitle>Enter Current Password</DialogTitle>
//                       <DialogContent>
//                         <TextField
//                           autoFocus
//                           margin="dense"
//                           label="Current Password"
//                           type="password"
//                           fullWidth
//                           value={currentPassword}
//                           onChange={handleCurrentPasswordChange}
//                           variant="outlined"
//                           InputLabelProps={{ style: { color: "#fff" } }}
//                           InputProps={{ style: { color: "#fff" } }}
//                         />
//                       </DialogContent>
//                       <Typography
//                         style={{
//                           color: "#007bff",
//                           margin: "0 1.5rem",
//                           cursor: "pointer",
//                         }}
//                         onClick={handleResetPassword}
//                       >
//                         Forgot Password? Click here to reset
//                       </Typography>
//                       <DialogActions>
//                         <Button onClick={handleClose} style={{ color: "#fff" }}>
//                           Cancel
//                         </Button>
//                         <Button
//                           onClick={handleNext}
//                           disabled={!currentPassword}
//                           style={{ color: "#fff" }}
//                         >
//                           Next
//                         </Button>
//                       </DialogActions>
//                     </>
//                   )}
//                   {step === 2 && (
//                     <>
//                       <DialogTitle>Enter New Password</DialogTitle>
//                       <DialogContent>
//                         <TextField
//                           autoFocus
//                           margin="dense"
//                           label="New Password"
//                           type="password"
//                           fullWidth
//                           value={newPassword}
//                           onChange={handleNewPasswordChange}
//                           variant="outlined"
//                           InputLabelProps={{ style: { color: "#fff" } }}
//                           InputProps={{ style: { color: "#fff" } }}
//                         />
//                         <TextField
//                           margin="dense"
//                           label="Confirm New Password"
//                           type="password"
//                           fullWidth
//                           value={confirmNewPassword}
//                           onChange={handleConfirmNewPasswordChange}
//                           variant="outlined"
//                           InputLabelProps={{ style: { color: "#fff" } }}
//                           InputProps={{ style: { color: "#fff" } }}
//                         />
//                       </DialogContent>
//                       <DialogActions>
//                         <Button
//                           onClick={() => setStep(1)}
//                           style={{ color: "#fff" }}
//                         >
//                           Back
//                         </Button>
//                         <Button
//                           onClick={handleNext}
//                           disabled={
//                             !newPassword || newPassword !== confirmNewPassword
//                           }
//                           style={{ color: "#fff" }}
//                         >
//                           Save
//                         </Button>
//                       </DialogActions>
//                     </>
//                   )}
//                 </Dialog>
//               </div>
//             </div>
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 flexDirection: "column",
//               }}
//             >
//               <Typography
//                 variant="h6"
//                 style={{ textAlign: "center", margin: "0.5rem 0" }}
//               >
//                 <span style={{ color: "#acebf9", fontStyle: "italic" }}>
//                   Assigned
//                 </span>{" "}
//                 Reports
//               </Typography>
//               <Paper className={classes.paperList}>
//                 <List>
//                   {assignedReports.map((item) => (
//                     <ListItem key={item.id}>
//                       <ListItemText
//                         primary={
//                           <Typography
//                             className={classes.listItem}
//                             variant="subtitle1"
//                           >
//                             <i
//                               className="material-icons navbar-icon"
//                               style={{ color: "#8065ed" }}
//                             >
//                               arrow_forward
//                             </i>
//                             {item.name}
//                           </Typography>
//                         }
//                       />
//                     </ListItem>
//                   ))}
//                 </List>
//               </Paper>
//             </div>
//           </div>
//           <div className="col-12 col-xl-9 col-md-8">
//             <div className={classes.userDataRoot}>
//               <div
//                 className={classes.userDataMain}
//                 style={{
//                   boxShadow: editMode
//                     ? "1px 1px 8px #1e90ff"
//                     : "1px 1px 8px #6a5f5f",
//                 }}
//               >
//                 <Typography variant="h5" className={classes.userContentStyle}>
//                   <span className={classes.userLabelStyle}>Full Name:</span>{" "}
//                   {editMode ? (
//                     <input
//                       type="text"
//                       name="fullname"
//                       value={userData.fullname || ""}
//                       onChange={handleInputChange}
//                       className={classes.userInputStyle}
//                     />
//                   ) : (
//                     userData.fullname || ""
//                   )}
//                 </Typography>
//                 <div className={classes.customDivider}></div>
//                 <Typography variant="h5" className={classes.userContentStyle}>
//                   <span className={classes.userLabelStyle}>Email:</span>{" "}
//                   {userData.email || ""}
//                 </Typography>
//                 <div className={classes.customDivider}></div>
//                 <Typography variant="h5" className={classes.userContentStyle}>
//                   <span className={classes.userLabelStyle}>Phone Number:</span>{" "}
//                   {editMode ? (
//                     <input
//                       type="text"
//                       name="contact"
//                       value={userData.contact || ""}
//                       onChange={handleInputChange}
//                       className={classes.userInputStyle}
//                     />
//                   ) : (
//                     userData.contact || ""
//                   )}
//                 </Typography>
//                 <div className={classes.customDivider}></div>
//                 <Typography variant="h5" className={classes.userContentStyle}>
//                   <span className={classes.userLabelStyle}>Created At:</span>{" "}
//                   {userData.createdAt
//                     ? new Date(userData.createdAt).toLocaleString()
//                     : ""}
//                 </Typography>
//                 <div className={classes.customDivider}></div>
//                 <Typography variant="h5" className={classes.userContentStyle}>
//                   <span className={classes.userLabelStyle}>Role:</span>{" "}
//                   {userData.role || ""}
//                   {editMode ? (
//                     <FontAwesomeIcon
//                       icon={faTimes}
//                       className={classes.icon}
//                       onClick={handleEditMode}
//                       style={{ color: "red" }}
//                     />
//                   ) : (
//                     <FontAwesomeIcon
//                       icon={faEdit}
//                       className={classes.icon}
//                       onClick={handleEditMode}
//                       style={{ color: "dodgerblue" }}
//                     />
//                   )}
//                   {editMode && (
//                     <FontAwesomeIcon
//                       icon={faCheck}
//                       onClick={handleEditSubmit}
//                       style={{
//                         color: "green",
//                         position: "absolute",
//                         fontSize: "2rem",
//                         right: "4rem",
//                         bottom: "1rem",
//                       }}
//                     />
//                   )}
//                 </Typography>
//               </div>
//             </div>
//             <div className="row">
//               <div
//                 className="col-xs-12 col-sm-12 col-lg-6"
//                 style={{
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   flexDirection: "column",
//                 }}
//               >
//                 <Typography
//                   variant="h6"
//                   style={{ textAlign: "center", margin: "0.5rem 0" }}
//                 >
//                   <span
//                     style={{ color: "rgb(172 249 174)", fontStyle: "italic" }}
//                   >
//                     Assigned
//                   </span>{" "}
//                   Dashboards
//                 </Typography>
//                 <Paper className={classes.paperList}>
//                   <List>
//                     {assignedDashboards.map((item, i) => (
//                       <ListItem key={i}>
//                         <ListItemText
//                           primary={
//                             <Typography
//                               className={classes.listItem}
//                               variant="subtitle1"
//                             >
//                               <i
//                                 className="material-icons navbar-icon"
//                                 style={{ color: "#8065ed" }}
//                               >
//                                 arrow_forward
//                               </i>
//                               {item.name}
//                             </Typography>
//                           }
//                         />
//                       </ListItem>
//                     ))}
//                   </List>
//                 </Paper>
//               </div>
//               <div
//                 className="col-xs-12 col-sm-12 col-lg-6"
//                 style={{
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   flexDirection: "column",
//                 }}
//               >
//                 <Typography
//                   variant="h6"
//                   style={{ textAlign: "center", margin: "0.5rem 0" }}
//                 >
//                   <span
//                     style={{ color: "rgb(247 249 150)", fontStyle: "italic" }}
//                   >
//                     Assigned
//                   </span>{" "}
//                   Groups
//                 </Typography>
//                 <Paper className={classes.paperList}>
//                   <List>
//                     {assignedGroups.map((item, i) => (
//                       <ListItem key={i}>
//                         <ListItemText
//                           primary={
//                             <Typography
//                               className={classes.listItem}
//                               variant="subtitle1"
//                             >
//                               <i
//                                 className="material-icons navbar-icon"
//                                 style={{ color: "#8065ed" }}
//                               >
//                                 arrow_forward
//                               </i>
//                               {item.name}
//                             </Typography>
//                           }
//                         />
//                       </ListItem>
//                     ))}
//                   </List>
//                 </Paper>
//               </div>
//             </div>
//           </div>
//         </div>
//         <br />
//         <br />
//         <section
//           className="selectDateRange row d-flex justify-content-between mb-3"
//           style={{ width: "70%", margin: "auto" }}
//         >
//           <form
//             className="row col-sm-12 d-flex justify-content-center"
//             id="activity-log-form"
//             onSubmit={getLog}
//           >
//             <section className="mb-4 row">
//               <section className="d-flex col-sm-6 justify-content-center flex-column">
//                 <label className="text-center" htmlFor="startDate">
//                   Starting Date and Time
//                 </label>
//                 <input type="datetime-local" name="startDate" id="startDate" />
//               </section>
//               <section className="d-flex col-sm-6 justify-content-center flex-column">
//                 <label className="text-center" htmlFor="endDate">
//                   Ending Date and Time
//                 </label>
//                 <input type="datetime-local" name="endDate" id="endDate" />
//               </section>
//             </section>
//             <section className="d-flex justify-content-center col col-sm-12">
//               <button
//                 type="submit"
//                 className="btn btn-primary d-block col-sm-2 mr-2"
//               >
//                 Get Log
//               </button>
//             </section>
//           </form>
//         </section>
//         <div className="d-flex justify-content-center align-content-center">
//           <div className="col-12 col-lg-9 col-md-10">
//             <ReactTabulator
//               columns={columns}
//               data={data}
//               options={{
//                 pagination: "local",
//                 paginationSize: 10,
//                 paginationSizeSelector: [10, 20, 50, 100],
//               }}
//               rowClick={(e, row) => setSelectedRow(row.getData().id)}
//               rowSelected={(row) => row.getData().id === selectedRow}
//             />
//           </div>
//         </div>
//         <br />
//         <br />
//       </main>
//     </div>
//   );
// };

// export default UserProfile;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";

import Navbar from "./Navbar";
import {
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Paper,
  TextField,
  Typography,
  Card,
  CardContent,
  Box,
  Grid,
  Divider,
} from "@mui/material";
import { deepPurple } from "@mui/material/colors";
import axios from "axios";
import config from "../config.js";
import Cookies from "universal-cookie";
import { ReactTabulator } from "react-tabulator";
import swal from "sweetalert";
import "../App.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTimes,
  faCheck,
  faUserCheck,
} from "@fortawesome/free-solid-svg-icons";
import { BsKey } from "react-icons/bs";
import default_avatar from "../images/default-user-avatar.jpg";
import mixpanel from "mixpanel-browser";

const MAX_SIZE = 2 * 1024 * 1024; // 2 MB
const MAX_WIDTH = 400; // 400 pixels
const MAX_HEIGHT = 400; // 400 pixels

const useStyles = makeStyles((theme) => ({
  avatar: {
    width: theme.spacing(16),
    height: theme.spacing(16),
  },
  button: {
    backgroundColor: deepPurple[500],
    color: theme.palette.getContrastText(deepPurple[500]),
    "&:hover": { backgroundColor: deepPurple[700] },
  },
  listItem: { fontWeight: "bold" },
  paperList: {
    width: "100%",
    maxHeight: 250,
    backgroundColor: "rgba(15,23,42,0.85)",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    color: "#e5e7eb",
    justifyContent: "center",
    marginBottom: "0.5rem",
    borderRadius: "12px",
    border: "1px solid rgba(148,163,184,0.25)",
  },
  userLabelStyle: {
    fontFamily: "'IBM Plex Sans', sans-serif",
    fontWeight: 600,
  },
  userContentStyle: {
    fontFamily: "'IBM Plex Sans', sans-serif",
    fontWeight: 400,
  },
  customDivider: {
    borderBottom: "1px solid rgba(148,163,184,0.4)",
    width: "100%",
    margin: "0.5rem 0",
  },
  userDataRoot: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  userDataMain: {
    display: "flex",
    position: "relative",
    flexDirection: "column",
    minHeight: "270px",
    marginBottom: "2rem",
    color: "#dee2e6",
    justifyContent: "space-evenly",
    width: "100%",
    borderRadius: "16px",
    padding: "1.5rem",
    background: "rgba(15, 23, 42, 0.7)",
    boxShadow:
      "0 0 0 1px rgba(255,255,255,0.03), 0 18px 45px rgba(15,23,42,0.9)",
    [`@media (max-width: 950px)`]: {
      fontSize: 12,
    },
  },
  userInputStyle: {
    border: "none",
    width: "78%",
    background: "transparent",
    color: "#fff",
    "&:focus": { outline: "none" },
  },
  icon: {
    position: "absolute",
    fontSize: "2rem",
    bottom: "1rem",
    right: "1rem",
  },
  darkTheme: { backgroundColor: "#0f172a", color: "#fff" },
  imageUploadInput: {
    display: "block",
    maxWidth: "250px",
    margin: "0.5rem 0",
    padding: "0.5rem 0.75rem",
    backgroundColor: "#020617",
    color: "#e5e7eb",
    border: "1px solid #334155",
    borderRadius: "999px",
    fontSize: "0.85rem",
    cursor: "pointer",
  },
  submitButton: {
    padding: "0.45rem 1.4rem",
    backgroundColor: "#3b82f6",
    color: "#fff",
    border: "none",
    borderRadius: "999px",
    cursor: "pointer",
    fontSize: "0.9rem",
    fontWeight: 500,
    "&:hover": { backgroundColor: "#2563eb" },
  },
  error: { color: "#f87171", fontSize: "0.8rem" },
}));

const columns = [
  { title: "Time", field: "timestamp" },
  { title: "User", field: "User" },
  { title: "Message", field: "message" },
  {
    title: "Details",
    field: "details",
    formatter: function (cell) {
      return "<button>Details</button>";
    },
    width: 200,
    align: "center",
    cellClick: function (e, cell) {
      let detailObj = cell.getData();
      swal(
        "Raw Log Details",
        JSON.stringify(detailObj, null, 2).replace(/[{}]/g, "")
      );
    },
  },
];

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const changeTimeFormat = (date) => {
  let time = new Date(date).toLocaleTimeString("en", {
    timeStyle: "short",
    hour12: false,
    timeZone: "UTC",
  });
  return `${
    months[date.getMonth()]
  }-${date.getDate()}-${date.getFullYear()} ${time}`;
};

const UserProfile = () => {
  const classes = useStyles();
  const cookies = new Cookies();
  const navigate = useNavigate();
  const [image, setImage] = useState(null);
  const [error, setError] = useState("");
  const [assignedReports, setAssignedReports] = useState([]);
  const [assignedDashboards, setAssignedDashboards] = useState([]);
  const [assignedGroups, setAssignedGroups] = useState([]);
  const [userData, setUserData] = useState({});
  const userId = parseInt(cookies.get("userID")) || 0;
  const [selectedRow, setSelectedRow] = useState(null);
  const [data, setData] = useState([]);
  const token = cookies.get("userToken") || "";
  const [dataUrl, setDataUrl] = useState("");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  // Password change states
  const [open, setOpen] = useState(false);
  const [step, setStep] = useState(1);
  const [password, setPassword] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");

  useEffect(() => {
    if (!userData?.photo?.data) {
      setDataUrl("");
      return;
    }
    const byteArray = new Uint8Array(userData.photo.data);
    const blob = new Blob([byteArray], { type: "image/jpeg" });
    const url = URL.createObjectURL(blob);

    setDataUrl(url);

    return () => URL.revokeObjectURL(url);
  }, [userData]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setStep(1);
    setPassword(false);
    setNewPassword("");
    setConfirmNewPassword("");
    setCurrentPassword("");
  };

  const handleNext = async () => {
    try {
      const res = await axios.post(
        `${config.BACKEND_URL}/profile/check-password`,
        { password: currentPassword, userId },
        { headers }
      );
      if (res.status === 200) {
        setPassword(true);
        if (step === 1) {
          mixpanel.track("Step 1 Reset Password", {
            userID: cookies.get("userID"),
          });
          setStep(2);
        } else if (
          password &&
          step === 2 &&
          newPassword === confirmNewPassword
        ) {
          mixpanel.track("Step 2 Reset Password", {
            userID: cookies.get("userID"),
          });
          await axios.post(
            `${config.BACKEND_URL}/profile/submit-password-profile`,
            {
              token,
              email: userData.email,
              name: userData.name,
              password: newPassword,
            },
            { headers }
          );
          mixpanel.track("New Password Updated", {
            userID: cookies.get("userID"),
          });
          swal("Success", "Password updated successfully!", "success");
          handleClose();
          navigate("/user-profile", { replace: true });
        }
      } else {
        throw new Error("Invalid password response");
      }
    } catch (err) {
      handleClose();
      swal(
        "Invalid Password",
        "Please try again with correct password",
        "error"
      );
      console.error(
        "Password check failed:",
        err.response?.data?.message || err.message
      );
    }
  };

  const handleCurrentPasswordChange = (event) =>
    setCurrentPassword(event.target.value);
  const handleNewPasswordChange = (event) => setNewPassword(event.target.value);
  const handleConfirmNewPasswordChange = (event) =>
    setConfirmNewPassword(event.target.value);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [reports, dashboards, groups, user] = await Promise.all([
          axios.post(
            `${config.BACKEND_URL}/profile/get-reports`,
            { userId },
            { headers }
          ),
          axios.post(
            `${config.BACKEND_URL}/profile/get-dashboards`,
            { userId },
            { headers }
          ),
          axios.post(
            `${config.BACKEND_URL}/profile/get-groups`,
            { userId },
            { headers }
          ),
          axios.post(
            `${config.BACKEND_URL}/profile/get-user-data`,
            { userId },
            { headers }
          ),
        ]);
        setAssignedReports(reports.data);
        setAssignedDashboards(dashboards.data);
        setAssignedGroups(groups.data);
        setUserData(user.data);
        mixpanel.track("Get Reports Dashboards Groups UserData Fetched", {
          userID: cookies.get("userID"),
        });
      } catch (err) {
        console.error(
          "Fetch data error:",
          err.response?.data?.message || err.message
        );
        swal("Error", "Failed to load user data", "error");
      }
    };
    fetchData();
  }, [userId, token]);

  const getLog = (e) => {
    e.preventDefault();
    mixpanel.track("User Profile Get Log Button Clicked", {
      userID: cookies.get("userID"),
    });
    let obj = Object.fromEntries(new FormData(e.target).entries());
    let startDate = new Date(obj.startDate + "Z");
    let endDate = new Date(obj.endDate + "Z");
    axios
      .get(`${config.BACKEND_URL}/logger/query`, {
        params: {
          from: changeTimeFormat(startDate),
          until: changeTimeFormat(endDate),
        },
      })
      .then((res) => {
        const filteredEntries = res.data.file.filter(
          (entry) => entry.User === userId
        );
        setData(filteredEntries);
      })
      .catch((err) => {
        console.error(
          "Get log error:",
          err.response?.data?.message || err.message
        );
        swal("Error", "Failed to fetch logs", "error");
      });
  };

  const [editMode, setEditMode] = useState(false);

  const handleEditMode = () => setEditMode(!editMode);

  const handleEditSubmit = async () => {
    setEditMode(false);
    try {
      await axios.post(
        `${config.BACKEND_URL}/profile/fill-details`,
        {
          fullname: userData.fullname,
          email: userData.email,
          contact: userData.contact,
          userId,
        },
        { headers }
      );
      mixpanel.track("User Info Updated", { userID: cookies.get("userID") });
      swal("Success", "Profile updated successfully!", "success");
    } catch (err) {
      console.error(
        "Edit submit error:",
        err.response?.data?.message || err.message
      );
      swal("Error", "Failed to update profile", "error");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "contact" && (value.length > 10 || !/^\d*$/.test(value)))
      return;
    setUserData((prev) => ({ ...prev, [name]: value }));
  };

  const authenticateMe = async () => {
    try {
      await axios.post(
        `${config.BACKEND_URL}/profile/authenticate-user`,
        { userId, email: userData.email, username: userData.name },
        { headers }
      );
      swal(
        "Mail Sent!",
        "Please check your email with registered email id",
        "warning"
      );
    } catch (err) {
      console.error(
        "Authentication error:",
        err.response?.data?.message || err.message
      );
      swal("Error", "Failed to send authentication email", "error");
    }
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (!file) return setError("No file selected.");
    if (file.size > MAX_SIZE)
      return setError("File size exceeds the 2 MB limit.");
    const img = new Image();
    const reader = new FileReader();
    reader.onload = (e) => {
      img.src = e.target.result;
    };
    img.onload = () => {
      if (img.width > MAX_WIDTH || img.height > MAX_HEIGHT) {
        setError(
          `Image dimensions should not exceed ${MAX_WIDTH}x${MAX_HEIGHT} pixels.`
        );
      } else {
        setError("");
        setImage(file);
      }
    };
    reader.readAsDataURL(file);
  };

  const handleImageSubmit = async (event) => {
    event.preventDefault();
    if (!image) {
      mixpanel.track("Upload Button Clicked Without Image", {
        userID: cookies.get("userID"),
      });
      return swal("Image not provided!!", "", "error");
    }
    const formData = new FormData();
    formData.append("image", image);
    formData.append("userId", userId);
    try {
      await axios.post(
        `${config.BACKEND_URL}/profile/update-user-photo`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      mixpanel.track("New Profile Image Uploaded", {
        userID: cookies.get("userID"),
      });
      swal("Success", "Profile image updated successfully!", "success");
      navigate("/user-profile", { replace: true });
    } catch (err) {
      console.error(
        "Image upload error:",
        err.response?.data?.message || err.message
      );
      swal("Error", "Failed to upload image", "error");
    }
  };

  const handleResetPassword = async () => {
    try {
      await axios.post(
        `${config.BACKEND_URL}/profile/send-password-reset-link`,
        { username: userData.name, email: userData.email, userId },
        { headers }
      );
      swal(
        "Password Reset Link Sent",
        "Please check your mail to reset password",
        "warning"
      );
      handleClose();
    } catch (err) {
      console.error(
        "Reset password error:",
        err.response?.data?.message || err.message
      );
      swal("Error", "Failed to send reset link", "error");
    }
  };

  return (
    <div className="Reports">
      <link
        href="https://fonts.googleapis.com/icon?family=Material+Icons"
        rel="stylesheet"
      />
      <link
        rel="preconnect"
        href="https://fonts.gstatic.com"
        crossOrigin="true"
      />
      <link
        href="https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,300;0,400;0,500;0,600;1,200;1,300;1,400;1,500&display=swap"
        rel="stylesheet"
      />
      <Navbar />
      <Box sx={{ minHeight: "100vh", bgcolor: "#0f1729" }}>
        <main>
          <Box
            sx={{
              px: { xs: 2, sm: 3, md: 4 },
              py: { xs: 2, md: 4 },
              maxWidth: "1300px",
              mx: "auto",
            }}
          >
            {/* Top heading */}
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                justifyContent: "space-between",
                alignItems: { xs: "flex-start", md: "center" },
                gap: { xs: 1.5, md: 0 },
                mb: { xs: 3, md: 4 },
              }}
            >
              <Box>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 700,
                    color: "white",
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  User Profile
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: "0.9rem", md: "1rem" },
                    color: "rgba(226,232,240,0.8)",
                    mt: 0.5,
                  }}
                >
                  Manage your account details, assignments, and activity logs.
                </Typography>
              </Box>
            </Box>

            {/* Top section: Avatar + User details */}
            <Grid container spacing={3}>
              {/* Avatar + upload + auth + change password */}
              <Grid item xs={12} md={4}>
                <Card
                  elevation={0}
                  sx={{
                    borderRadius: "16px",
                    background: "rgba(15, 23, 42, 0.6)",
                    backdropFilter: "blur(12px)",
                    WebkitBackdropFilter: "blur(12px)",
                    border: "1px solid rgba(148,163,184,0.25)",
                    boxShadow:
                      "0 0 0 1px rgba(255,255,255,0.03), 0 18px 45px rgba(15,23,42,0.9)",
                  }}
                >
                  <CardContent>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 1.5,
                        minHeight: "270px",
                        justifyContent: "space-evenly",
                      }}
                    >
                      {userData.photo?.data ? (
                        <Avatar
                          src={dataUrl}
                          alt="User Avatar"
                          className={classes.avatar}
                        />
                      ) : (
                        <Avatar
                          src={default_avatar}
                          alt="User Avatar"
                          className={classes.avatar}
                        />
                      )}

                      <form
                        onSubmit={handleImageSubmit}
                        style={{ width: "100%" }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <input
                            type="file"
                            name="image"
                            className={classes.imageUploadInput}
                            onChange={handleImageChange}
                            accept="image/*"
                          />
                          {error && (
                            <div className={classes.error}>
                              <p>{error}</p>
                            </div>
                          )}
                          <button
                            type="submit"
                            className={`${classes.submitButton} ${classes.darkTheme}`}
                          >
                            Upload
                          </button>
                        </Box>
                      </form>

                      <Typography
                        variant="h5"
                        sx={{
                          mt: 1,
                          color: "white",
                          fontWeight: 600,
                          fontSize: { xs: "1.1rem", md: "1.25rem" },
                          textAlign: "center",
                        }}
                      >
                        {userData.name}
                      </Typography>

                      <Box sx={{ mt: 0.5 }}>
                        {userId === 99999 || userData.isEmailAuthenticated ? (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: 1,
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faUserCheck}
                              style={{ color: "#4ade80", fontSize: "1.3rem" }}
                            />
                            <span
                              style={{
                                fontSize: "1rem",
                                color: "#e5e7eb",
                              }}
                            >
                              Verified
                            </span>
                          </Box>
                        ) : (
                          <Button
                            variant="contained"
                            className={classes.button}
                            sx={{
                              mt: 1,
                              borderRadius: "999px",
                              px: 3,
                              textTransform: "none",
                            }}
                            onClick={authenticateMe}
                          >
                            Authenticate
                          </Button>
                        )}
                      </Box>

                      <Box sx={{ mt: 1, width: "100%", textAlign: "center" }}>
                        <Button
                          variant="outlined"
                          startIcon={<BsKey />}
                          onClick={handleOpen}
                          sx={{
                            textTransform: "none",
                            borderRadius: "999px",
                            borderColor: "#334155",
                            color: "#e5e7eb",
                            "&:hover": { borderColor: "#60a5fa" },
                            fontSize: { xs: "0.8rem", md: "0.9rem" },
                          }}
                        >
                          Change Password
                        </Button>
                      </Box>

                      {/* Dialog for password change (logic unchanged) */}
                      <Dialog
                        open={open}
                        onClose={handleClose}
                        PaperProps={{
                          style: {
                            backgroundColor: "#020617",
                            color: "#fff",
                            boxShadow:
                              "0 0 0 1px rgba(148,163,184,0.25), 0 12px 30px rgba(15,23,42,0.9)",
                            borderRadius: "16px",
                          },
                        }}
                      >
                        {step === 1 && (
                          <>
                            <DialogTitle>Enter Current Password</DialogTitle>
                            <DialogContent>
                              <TextField
                                autoFocus
                                margin="dense"
                                label="Current Password"
                                type="password"
                                fullWidth
                                value={currentPassword}
                                onChange={handleCurrentPasswordChange}
                                variant="outlined"
                                InputLabelProps={{
                                  style: { color: "#e5e7eb" },
                                }}
                                InputProps={{ style: { color: "#fff" } }}
                              />
                            </DialogContent>
                            <Typography
                              style={{
                                color: "#60a5fa",
                                margin: "0 1.5rem",
                                cursor: "pointer",
                                fontSize: "0.85rem",
                              }}
                              onClick={handleResetPassword}
                            >
                              Forgot Password? Click here to reset
                            </Typography>
                            <DialogActions>
                              <Button
                                onClick={handleClose}
                                style={{ color: "#e5e7eb" }}
                              >
                                Cancel
                              </Button>
                              <Button
                                onClick={handleNext}
                                disabled={!currentPassword}
                                style={{ color: "#e5e7eb" }}
                              >
                                Next
                              </Button>
                            </DialogActions>
                          </>
                        )}
                        {step === 2 && (
                          <>
                            <DialogTitle>Enter New Password</DialogTitle>
                            <DialogContent>
                              <TextField
                                autoFocus
                                margin="dense"
                                label="New Password"
                                type="password"
                                fullWidth
                                value={newPassword}
                                onChange={handleNewPasswordChange}
                                variant="outlined"
                                InputLabelProps={{
                                  style: { color: "#e5e7eb" },
                                }}
                                InputProps={{ style: { color: "#fff" } }}
                              />
                              <TextField
                                margin="dense"
                                label="Confirm New Password"
                                type="password"
                                fullWidth
                                value={confirmNewPassword}
                                onChange={handleConfirmNewPasswordChange}
                                variant="outlined"
                                InputLabelProps={{
                                  style: { color: "#e5e7eb" },
                                }}
                                InputProps={{ style: { color: "#fff" } }}
                              />
                            </DialogContent>
                            <DialogActions>
                              <Button
                                onClick={() => setStep(1)}
                                style={{ color: "#e5e7eb" }}
                              >
                                Back
                              </Button>
                              <Button
                                onClick={handleNext}
                                disabled={
                                  !newPassword ||
                                  newPassword !== confirmNewPassword
                                }
                                style={{ color: "#e5e7eb" }}
                              >
                                Save
                              </Button>
                            </DialogActions>
                          </>
                        )}
                      </Dialog>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              {/* User data card */}
              <Grid item xs={12} md={8}>
                <Box className={classes.userDataRoot}>
                  <Box
                    className={classes.userDataMain}
                    sx={{
                      boxShadow: editMode
                        ? "0 0 0 1px rgba(96,165,250,0.6), 0 18px 45px rgba(15,23,42,0.9)"
                        : "0 0 0 1px rgba(148,163,184,0.35), 0 18px 45px rgba(15,23,42,0.9)",
                    }}
                  >
                    <Typography
                      variant="h5"
                      className={classes.userContentStyle}
                      sx={{ fontSize: { xs: "0.95rem", md: "1.1rem" } }}
                    >
                      <span className={classes.userLabelStyle}>Full Name:</span>{" "}
                      {editMode ? (
                        <input
                          type="text"
                          name="fullname"
                          value={userData.fullname || ""}
                          onChange={handleInputChange}
                          className={classes.userInputStyle}
                        />
                      ) : (
                        userData.fullname || ""
                      )}
                    </Typography>
                    <div className={classes.customDivider}></div>

                    <Typography
                      variant="h5"
                      className={classes.userContentStyle}
                      sx={{ fontSize: { xs: "0.95rem", md: "1.1rem" } }}
                    >
                      <span className={classes.userLabelStyle}>Email:</span>{" "}
                      {userData.email || ""}
                    </Typography>
                    <div className={classes.customDivider}></div>

                    <Typography
                      variant="h5"
                      className={classes.userContentStyle}
                      sx={{ fontSize: { xs: "0.95rem", md: "1.1rem" } }}
                    >
                      <span className={classes.userLabelStyle}>
                        Phone Number:
                      </span>{" "}
                      {editMode ? (
                        <input
                          type="text"
                          name="contact"
                          value={userData.contact || ""}
                          onChange={handleInputChange}
                          className={classes.userInputStyle}
                        />
                      ) : (
                        userData.contact || ""
                      )}
                    </Typography>
                    <div className={classes.customDivider}></div>

                    <Typography
                      variant="h5"
                      className={classes.userContentStyle}
                      sx={{ fontSize: { xs: "0.95rem", md: "1.1rem" } }}
                    >
                      <span className={classes.userLabelStyle}>
                        Created At:
                      </span>{" "}
                      {userData.createdAt
                        ? new Date(userData.createdAt).toLocaleString()
                        : ""}
                    </Typography>
                    <div className={classes.customDivider}></div>

                    <Typography
                      variant="h5"
                      className={classes.userContentStyle}
                      sx={{ fontSize: { xs: "0.95rem", md: "1.1rem" } }}
                    >
                      <span className={classes.userLabelStyle}>Role:</span>{" "}
                      {userData.role || ""}
                      {editMode ? (
                        <FontAwesomeIcon
                          icon={faTimes}
                          className={classes.icon}
                          onClick={handleEditMode}
                          style={{ color: "red" }}
                        />
                      ) : (
                        <FontAwesomeIcon
                          icon={faEdit}
                          className={classes.icon}
                          onClick={handleEditMode}
                          style={{ color: "dodgerblue" }}
                        />
                      )}
                      {editMode && (
                        <FontAwesomeIcon
                          icon={faCheck}
                          onClick={handleEditSubmit}
                          style={{
                            color: "green",
                            position: "absolute",
                            fontSize: "2rem",
                            right: "4rem",
                            bottom: "1rem",
                          }}
                        />
                      )}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>

            {/* Assigned Reports, Dashboards, Groups in ONE ROW */}
            <Grid container spacing={3} sx={{ mt: 1 }}>
              <Grid item xs={12} md={4}>
                <Card
                  elevation={0}
                  sx={{
                    borderRadius: "16px",
                    background: "rgba(15, 23, 42, 0.6)",
                    backdropFilter: "blur(12px)",
                    WebkitBackdropFilter: "blur(12px)",
                    border: "1px solid rgba(148,163,184,0.25)",
                    boxShadow:
                      "0 0 0 1px rgba(255,255,255,0.03), 0 18px 45px rgba(15,23,42,0.9)",
                  }}
                >
                  <CardContent>
                    <Typography
                      variant="h6"
                      sx={{
                        textAlign: "center",
                        mb: 1,
                        fontSize: { xs: "0.95rem", md: "1.05rem" },
                      }}
                    >
                      <span style={{ color: "#acebf9", fontStyle: "italic" }}>
                        Assigned
                      </span>{" "}
                      Reports
                    </Typography>
                    <Paper className={classes.paperList} elevation={0}>
                      <List dense>
                        {assignedReports.map((item) => (
                          <ListItem key={item.id}>
                            <ListItemText
                              primary={
                                <Typography
                                  className={classes.listItem}
                                  variant="subtitle2"
                                >
                                  <i
                                    className="material-icons navbar-icon"
                                    style={{ color: "#8065ed", marginRight: 4 }}
                                  >
                                    arrow_forward
                                  </i>
                                  {item.name}
                                </Typography>
                              }
                            />
                          </ListItem>
                        ))}
                      </List>
                    </Paper>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} md={4}>
                <Card
                  elevation={0}
                  sx={{
                    borderRadius: "16px",
                    background: "rgba(15, 23, 42, 0.6)",
                    backdropFilter: "blur(12px)",
                    WebkitBackdropFilter: "blur(12px)",
                    border: "1px solid rgba(148,163,184,0.25)",
                    boxShadow:
                      "0 0 0 1px rgba(255,255,255,0.03), 0 18px 45px rgba(15,23,42,0.9)",
                  }}
                >
                  <CardContent>
                    <Typography
                      variant="h6"
                      sx={{
                        textAlign: "center",
                        mb: 1,
                        fontSize: { xs: "0.95rem", md: "1.05rem" },
                      }}
                    >
                      <span
                        style={{
                          color: "rgb(172 249 174)",
                          fontStyle: "italic",
                        }}
                      >
                        Assigned
                      </span>{" "}
                      Dashboards
                    </Typography>
                    <Paper className={classes.paperList} elevation={0}>
                      <List dense>
                        {assignedDashboards.map((item, i) => (
                          <ListItem key={i}>
                            <ListItemText
                              primary={
                                <Typography
                                  className={classes.listItem}
                                  variant="subtitle2"
                                >
                                  <i
                                    className="material-icons navbar-icon"
                                    style={{ color: "#8065ed", marginRight: 4 }}
                                  >
                                    arrow_forward
                                  </i>
                                  {item.name}
                                </Typography>
                              }
                            />
                          </ListItem>
                        ))}
                      </List>
                    </Paper>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} md={4}>
                <Card
                  elevation={0}
                  sx={{
                    borderRadius: "16px",
                    background: "rgba(15, 23, 42, 0.6)",
                    backdropFilter: "blur(12px)",
                    WebkitBackdropFilter: "blur(12px)",
                    border: "1px solid rgba(148,163,184,0.25)",
                    boxShadow:
                      "0 0 0 1px rgba(255,255,255,0.03), 0 18px 45px rgba(15,23,42,0.9)",
                  }}
                >
                  <CardContent>
                    <Typography
                      variant="h6"
                      sx={{
                        textAlign: "center",
                        mb: 1,
                        fontSize: { xs: "0.95rem", md: "1.05rem" },
                      }}
                    >
                      <span
                        style={{
                          color: "rgb(247 249 150)",
                          fontStyle: "italic",
                        }}
                      >
                        Assigned
                      </span>{" "}
                      Groups
                    </Typography>
                    <Paper className={classes.paperList} elevation={0}>
                      <List dense>
                        {assignedGroups.map((item, i) => (
                          <ListItem key={i}>
                            <ListItemText
                              primary={
                                <Typography
                                  className={classes.listItem}
                                  variant="subtitle2"
                                >
                                  <i
                                    className="material-icons navbar-icon"
                                    style={{ color: "#8065ed", marginRight: 4 }}
                                  >
                                    arrow_forward
                                  </i>
                                  {item.name}
                                </Typography>
                              }
                            />
                          </ListItem>
                        ))}
                      </List>
                    </Paper>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            {/* Activity Log + Table */}
            <Box sx={{ mt: 4 }}>
              <Card
                elevation={0}
                sx={{
                  borderRadius: "16px",
                  background: "rgba(15, 23, 42, 0.6)",
                  backdropFilter: "blur(12px)",
                  WebkitBackdropFilter: "blur(12px)",
                  border: "1px solid rgba(148,163,184,0.25)",
                  boxShadow:
                    "0 0 0 1px rgba(255,255,255,0.03), 0 18px 45px rgba(15,23,42,0.9)",
                }}
              >
                <CardContent>
                  <Typography
                    variant="h6"
                    sx={{
                      mb: 2,
                      fontWeight: 600,
                      color: "white",
                      fontSize: { xs: "1rem", md: "1.1rem" },
                    }}
                  >
                    Activity Log
                  </Typography>

                  <Divider sx={{ mb: 2, borderColor: "#1e293b" }} />

                  {/* Date range form (logic unchanged) */}
                  <Box
                    sx={{
                      maxWidth: "800px",
                      mx: "auto",
                      mb: 3,
                    }}
                  >
                    <form
                      className="row col-sm-12 d-flex justify-content-center"
                      id="activity-log-form"
                      onSubmit={getLog}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: { xs: "column", sm: "row" },
                          gap: 2,
                          mb: 2,
                        }}
                      >
                        <Box
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "stretch",
                          }}
                        >
                          <label
                            className="text-center"
                            htmlFor="startDate"
                            style={{
                              color: "#e5e7eb",
                              fontSize: "0.9rem",
                              marginBottom: "0.25rem",
                            }}
                          >
                            Starting Date and Time
                          </label>
                          <input
                            type="datetime-local"
                            name="startDate"
                            id="startDate"
                            style={{
                              backgroundColor: "#020617",
                              color: "#e5e7eb",
                              borderRadius: "8px",
                              border: "1px solid #334155",
                              padding: "0.4rem 0.6rem",
                              fontSize: "0.9rem",
                            }}
                          />
                        </Box>
                        <Box
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "stretch",
                          }}
                        >
                          <label
                            className="text-center"
                            htmlFor="endDate"
                            style={{
                              color: "#e5e7eb",
                              fontSize: "0.9rem",
                              marginBottom: "0.25rem",
                            }}
                          >
                            Ending Date and Time
                          </label>
                          <input
                            type="datetime-local"
                            name="endDate"
                            id="endDate"
                            style={{
                              backgroundColor: "#020617",
                              color: "#e5e7eb",
                              borderRadius: "8px",
                              border: "1px solid #334155",
                              padding: "0.4rem 0.6rem",
                              fontSize: "0.9rem",
                            }}
                          />
                        </Box>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          mt: 1,
                        }}
                      >
                        <Button
                          type="submit"
                          variant="contained"
                          sx={{
                            bgcolor: "#3b82f6",
                            textTransform: "none",
                            borderRadius: "999px",
                            px: 4,
                            "&:hover": { bgcolor: "#2563eb" },
                            fontSize: "0.9rem",
                          }}
                        >
                          Get Log
                        </Button>
                      </Box>
                    </form>
                  </Box>

                  {/* Table */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      overflowX: "auto",
                    }}
                  >
                    <Box sx={{ width: "100%", maxWidth: "900px" }}>
                      <ReactTabulator
                        columns={columns}
                        data={data}
                        options={{
                          pagination: "local",
                          paginationSize: 10,
                          paginationSizeSelector: [10, 20, 50, 100],
                        }}
                        rowClick={(e, row) => setSelectedRow(row.getData().id)}
                        rowSelected={(row) => row.getData().id === selectedRow}
                      />
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Box>
          </Box>
        </main>
      </Box>
    </div>
  );
};

export default UserProfile;
